import {
  ColDef,
  IServerSideGetRowsParams,
  GridReadyEvent,
} from "ag-grid-community";

import AgGrid from "../../../UI/AgGrid";
import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { createGraphQLClientWithMiddleware } from "../../../../services/graphqlClient";
import { GraphQLClient } from "graphql-request";

import { PURCHASE_BY_PRODUCT_EXPORT_VIEW } from "services/Purchase/Report/PurchaseByProductExportViewAggrid";
import { numberFormatter } from "utils/Formatter/Global";
import CustomizedBoxTable from "components/Custom/CustomizedBoxTable";

interface Props {
  gridRef: RefObject<AgGridReact>;
  height?: string | number;
}

export const PurchaseByProductTable = ({ gridRef, height }: Props) => {
  const columnDefs: ColDef[] = [
    {
      field: "item_unique_id",
      headerName: "รหัสสินค้า",
      filter: "agTextColumnFilter",
    },
    {
      field: "item_name",
      headerName: "ชื่อสินค้า",
      filter: "agTextColumnFilter",
    },
    {
      field: "qty",
      headerName: "จำนวน",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) => numberFormatter(params.value ?? 0),
      cellStyle: {
        display: "flex",
        justifyContent: "flex-end",
      },
      //   headerClass: "ag-end-header",
    },
    {
      field: "uom_name",
      headerName: "หน่วย",
      filter: "agTextColumnFilter",
    },
    {
      field: "net_amount",
      headerName: "มูลค่ารวมสุทธิ",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) => numberFormatter(params.value ?? 0),
      cellStyle: { display: "flex", justifyContent: "flex-end" },
      //   headerClass: "ag-end-header",
    },
    {
      field: "additional_discount",
      headerName: "ส่วนลดเพิ่มเติม",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) => numberFormatter(params.value ?? 0),
      cellStyle: { display: "flex", justifyContent: "flex-end" },
      //   headerClass: "ag-end-header",
    },
    {
      field: "pre_vat_amount",
      headerName: "มูลค่าก่อนภาษี",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) => numberFormatter(params.value ?? 0),
      cellStyle: { display: "flex", justifyContent: "flex-end" },
      //   headerClass: "ag-end-header",
    },
    {
      field: "vat_amount",
      headerName: "ภาษีมูลค่าเพิ่มรวม",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) => numberFormatter(params.value ?? 0),
      cellStyle: { display: "flex", justifyContent: "flex-end" },
      //   headerClass: "ag-end-header",
    },
    {
      field: "pre_discount_amount",
      headerName: "มูลค่าก่อนหักส่วนลด",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) => numberFormatter(params.value ?? 0),
      cellStyle: { display: "flex", justifyContent: "flex-end" },
      //   headerClass: "ag-end-header",
    },
    {
      field: "withholding_tax_amount",
      headerName: "ภาษีหัก ณ ที่จ่าย",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) => numberFormatter(params.value ?? 0),
      cellStyle: { display: "flex", justifyContent: "flex-end" },
      //   headerClass: "ag-end-header",
    },
    {
      field: "total_amount",
      headerName: "จำนวนเงินชำระทั้งสิ้น",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) => numberFormatter(params.value ?? 0),
      cellStyle: { display: "flex", justifyContent: "flex-end" },
      //   headerClass: "ag-end-header",
    },
  ];

  const graphQLClient: GraphQLClient =
    createGraphQLClientWithMiddleware("purchase");

  const datasource = {
    async getRows(params: IServerSideGetRowsParams) {
      const { request } = params;
      const { startRow, endRow, filterModel, sortModel } = request;

      try {
        const { PurchaseByProductExportViewAggrid } =
          await graphQLClient.request(PURCHASE_BY_PRODUCT_EXPORT_VIEW, {
            aggridInput: {
              startRow,
              endRow,
              filterModel: filterModel,
              sortModel,
            },
          });

        params.success({
          rowData: PurchaseByProductExportViewAggrid.results,
          rowCount: PurchaseByProductExportViewAggrid.count,
        });
      } catch (err) {
        params.fail();
      }
    },
  };

  const onGridReady = (params: GridReadyEvent) => {
    params.api.setServerSideDatasource(datasource);
  };

  return (
    <CustomizedBoxTable height={height}>
      <AgGrid
        // height={665}
        ref={gridRef}
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        headerClass={["grid-header-end"]}
      />
    </CustomizedBoxTable>
  );
};
